import Typography from "@common/components/Typography";
import { Tooltip, useTheme } from "@mui/material";
import * as React from "react";
import { GlobalMonitoringStatus, ItemMonitoringStatus } from "../type";
import { responsiveFontSize } from "@common/components/Typography/style";
import { useMemo } from "react";

type RealTimeLabelProps = {
  status?: ItemMonitoringStatus;
  disabled?: boolean;
  isContainerTitle?: boolean;
  globalStatus: GlobalMonitoringStatus;
};

const RealTimeLabel = (props: React.PropsWithChildren<RealTimeLabelProps>) => {
  const {
    status = "default",
    disabled = false,
    isContainerTitle = false,
    globalStatus,
  } = props;
  const theme = useTheme();

  const StatusComputeStyle = useMemo(() => {
    if (disabled) {
      return {
        color: theme.palette.common.grey.g828282,
      };
    } else if (status === "paused" || globalStatus === "paused") {
      return {
        color: theme.palette.device.border,
      };
    } else {
      return { color: theme.palette.common.white };
    }
  }, [theme, status, globalStatus, disabled]);

  const computedSize = useMemo(
    () => responsiveFontSize(theme, isContainerTitle ? "small" : "smaller"),
    [isContainerTitle]
  );

  return (
    <Tooltip title={props.children} arrow>
      <Typography
        size={isContainerTitle ? "small" : "smaller"}
        sx={{
          computedSize,
          bottom: isContainerTitle ? "2.5rem" : "-1rem",
          [theme.breakpoints.up("lg")]: {
            bottom: isContainerTitle ? "2.7rem" : "-1.175rem",
          },
          [theme.breakpoints.up("xl")]: {
            bottom: isContainerTitle ? "2.7rem" : "-1.55rem",
          },
          [`${theme.breakpoints.up("xl")} and (min-aspect-ratio: 20/9)`]: {
            bottom: isContainerTitle ? "2.7rem" : "-1.175rem",
          },
          position: "absolute",
          StatusComputeStyle,
          maxWidth: "16rem",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          textAlign: "center",
          color: isContainerTitle ? "common.grey.g828282" : "common.white",
        }}
      >
        {props.children}
      </Typography>
    </Tooltip>
  );
};

export default RealTimeLabel;
